// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-insight-view{display:flex;flex-direction:column;min-height:100%;position:relative;height:100%}.ac-insight-view__content{background:#F9F9F9;flex-grow:1;padding:15px 30px;position:relative}.ac-insight-view__block{margin-bottom:1rem}\n", ""]);
// Exports
module.exports = exports;
